import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internalservererror',
  templateUrl: './internalservererror.component.html',
  styleUrls: ['./internalservererror.component.less']
})
export class InternalservererrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
